var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSamllimageabouutus2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 59,
    viewBox: "0 0 67 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_841_289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47378 53.4449C11.1965 44.4751 21.9603 29.3975 43.2345 40.8453",
    stroke: "#E57C1A",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0314 39.4359C38.6193 30.7051 37.7441 12.2003 61.5397 8.02765",
    stroke: "#FFDF73",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2381 41.3792C35.8665 41.5818 18.1886 36.0419 22.4509 12.2623",
    stroke: "white",
    strokeWidth: 8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_841_289",
    x: 0.645996,
    y: 0.0877609,
    width: 65.5845,
    height: 58.5189,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_841_289"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamllimageabouutus2);
export default __webpack_public_path__ + "static/media/samllimageabouutus2.9ae5f78e40e8baf32e30ab682051f511.svg";
export { ForwardRef as ReactComponent };